export default __webpack_public_path__ + "static/media/JQuery.53178394.png";